export default function useQuery() {
  const route = useRoute()
  const router = useRouter()

  async function setQuery(value: object) {
    const { params, query, hash } = route
    await router.replace({
      params,
      query: { ...query, ...value },
      hash,
    })
  }

  return {
    setQuery,
  }
}
